import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Deletereason }  from '../../shared/misc-classes';


@Component({
  selector: 'app-delete-confirm-dialog',
  templateUrl: 'delete-confirm-dialog.html'
})
export class DeleteConfirmDialog {
  errorMessage:string = '';
  constructor(
    public dialogRef: MatDialogRef<DeleteConfirmDialog>,
    @Inject(MAT_DIALOG_DATA) public data: Deletereason) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getAddCommentLabels(){
    
        
        return "Reason for Deletion *";
     
    
    
  }
  confirmClick(){
    this.errorMessage = '';
    if(this.data.comments == null || this.data.comments == ''){
          this.errorMessage = 'Please Enter Reason for Deletion';
          return;
    }
    this.dialogRef.close(true);
  }
}

